import { biometricBaseUrl } from "constant";

export const BioEndpointConst = {
    bioAuthLoginUrl: `${biometricBaseUrl}/auth/login`,
    bioDeviceInfoUrl: `${biometricBaseUrl}/device/info`,
    bioEmployeesListUrl: `${biometricBaseUrl}/employee/list`,
    bioEmployeesSyncDbUrl: `${biometricBaseUrl}/employee/sync-to-db`,
    bioAttendancesLogUrl: `${biometricBaseUrl}/attendances/logs`,
    bioAttendancesLogSyncDbUrl: `${biometricBaseUrl}/attendances/sync-to-db`,
    bioAttendancesLogCalculateUrl: `${biometricBaseUrl}/attendances/calculate`,

}